import { render } from "./AboutUsComp.vue?vue&type=template&id=63c3f646&scoped=true"
import script from "./AboutUsComp.vue?vue&type=script&lang=js"
export * from "./AboutUsComp.vue?vue&type=script&lang=js"

import "./AboutUsComp.vue?vue&type=style&index=0&id=63c3f646&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\LENOVO\\Documents\\workspace\\tulumoutdoor_website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63c3f646"]])

export default __exports__